import { FormControlLabel, FormGroup, Switch, Typography } from '@mui/material'

import { t } from 'i18n'

export default function ManageRecognitionOnboarding({ formik }) {
  return (
    <>
      <Typography variant="h6" gutterBottom>
        {t('recognitions.onboarding.title')}
      </Typography>

      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              id="include_in_onboarding"
              name="include_in_onboarding"
              checked={formik.values.include_in_onboarding}
              onChange={formik.handleChange}
            />
          }
          label={
            <Typography variant="body2">
              {t('recognitions.onboarding.includeInOnboarding')}
            </Typography>
          }
        />
      </FormGroup>

      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        {t('recognitions.onboarding.description')}
      </Typography>
    </>
  )
}
